import React from 'react'
import * as Styled from './MainContent.styles'

const MainContent = ({ content }) => {
  // If it is coming from the CSM, filter out empty paragraphs. Otherwise, render the content as is.
  if (!content || !Array.isArray(content)) {
    return (
      <Styled.MainContent className="main-content">
        {content}
      </Styled.MainContent>
    )
  }

  // remove empty paragraphs from content
  const filteredContent = content?.filter(
    (item) => item?.props?.children?.[0]?.[1] !== ''
  )

  return (
    <Styled.MainContent className="main-content">
      {filteredContent}
    </Styled.MainContent>
  )
}

/* eslint-enable react/no-danger */
export default MainContent
